var render, staticRenderFns
import script from "./ClosedArchStencil.vue?vue&type=script&lang=js&"
export * from "./ClosedArchStencil.vue?vue&type=script&lang=js&"
import style0 from "./ClosedArchStencil.vue?vue&type=style&index=0&id=580ce5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ce5c8",
  null
  
)

export default component.exports